module.exports = __webpack_public_path__ + "static/media/quotes-icon.fc72e3b2.svg";